import OverlayWrapper from '@/components/ui/OverlayWrapper'
import BIcon from '@/components/ui/BIcon'
import {getNavigatorLanguage} from '@dxp-multiapp/mymachine/src/plugin/mixins/commonMixin'
import langs from 'langs'

const _commonMixin = function (Vue) {
  Vue.config.ignoredElements = ['bicon', 'b-icon']

  Vue.component('overlay-wrapper', OverlayWrapper)
  Vue.component('b-icon', BIcon)

  Vue.directive('click-outside', {
    bind(el, binding, vnode) {
      el.clickOutsideEvent = (event) => {
        const _isOutsideEvent = !(el == event.target || el.contains(event.target))
        const _dPicker = document.getElementsByClassName('mx-datepicker-popup')
        const _isNotFromDatePicker = !(_dPicker.length && _dPicker[0].contains(event.target))

        if (_isOutsideEvent && _isNotFromDatePicker) { vnode.context[binding.expression](event) }
      }
      document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind(el) {
      document.body.removeEventListener('click', el.clickOutsideEvent)
    }
  })

  Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
  })

  Vue.filter('formatDate', val => {
    const ts = new Date(val)
    const options = {day: 'numeric', month: 'short', year: 'numeric'}
    return ts.toLocaleDateString(getNavigatorLanguage(), options)
  })

  // languageMixin
  Vue.mixin({
    filters: {
      translate(value, labels, key = null) {
        if (labels && labels[key] && typeof labels[key][value] === 'string') return labels[key][value]
        else if (Object.keys(labels).length > 0) return `{ ${key} | ${value} }`
        else return '~~~~~'
      },
      translateFallback(value, labels, key = null) {
        const sanitizedValue = value.replace(/[^a-zA-Z ]/g, '').replace(/ +(?= )/g, '').replace(/[ ]/g, '-')
        if (labels && labels[key] && typeof labels[key][sanitizedValue] === 'string') return labels[key][sanitizedValue]
        else if (labels.show === 'concepts') return `{ ${key} | ${sanitizedValue} }`
        else if (Object.keys(labels).length > 0) return value
        else return '~~~~~'
      },
      replace(value, keyword, replacement) {
        return value.replace(keyword, replacement)
      }
    },
    computed: {
      labels() {
        return this.$store.getters['servicelibrary/getConcepts']
      },
      translatedLabel() {
        return (conceptKey, conceptPath) => this.$options.filters.translate(conceptKey, this.labels, conceptPath)
      }
    },
    methods: {
      translateLocale(facet) {
        return langs.where('1', facet.substr(0, 2)) ? (langs.where('1', facet.substr(0, 2)).local + ' (' + facet.substr(2, 2) + ')') : facet
      }
    }
  })

  return {}
}

export default _commonMixin
